import { useCallback } from "react";
import { useNavigate } from "react-router";
import { ROUTES } from "../components/shared/constant";

interface UseTenantCreationProps {
  instanceId: string;
  getQueryString: () => string;
  setIsShowCreateTenant: (value: boolean) => void;
  setCreateOwnInfrastructure: (value: boolean) => void;
  setShowExternalTenantCreationError: (value: boolean) => void;
  setIsCheckResourceFailed: (value: boolean) => void;
  setNotificationMessage: (message: string) => void;
  setIsSetupFinished: (value: boolean) => void;
  getUserAccess: () => Promise<boolean>;
  checkIfResourceExist: (urlInstanceId?: string) => void;
}

export const useTenantCreation = ({
  instanceId,
  getQueryString,
  setIsShowCreateTenant,
  setCreateOwnInfrastructure,
  setShowExternalTenantCreationError,
  setIsCheckResourceFailed,
  setNotificationMessage,
  setIsSetupFinished,
  getUserAccess,
  checkIfResourceExist,
}: UseTenantCreationProps) => {
  const navigate = useNavigate();

  const createResourceForTenant = useCallback(() => {
    // Local resources are always available — no SPC tenant creation needed
    setCreateOwnInfrastructure(false);
    setIsShowCreateTenant(false);
    setIsSetupFinished(true);
    setIsCheckResourceFailed(false);
    getUserAccess();
  }, [
    setCreateOwnInfrastructure,
    setIsShowCreateTenant,
    setIsSetupFinished,
    setIsCheckResourceFailed,
    getUserAccess,
  ]);

  const createOwnInfrastructureFn = useCallback(() => {
    setIsShowCreateTenant(false);
    setCreateOwnInfrastructure(true);
    navigate(ROUTES.CREATETENANT + getQueryString(), {
      replace: true,
      state: {
        isSignupProcess: true,
        isEditProcess: false,
        id: "",
      },
    });
  }, [navigate, getQueryString, setIsShowCreateTenant, setCreateOwnInfrastructure]);

  const hideExternalTenantCreationError = useCallback(() => {
    setShowExternalTenantCreationError(false);
    checkIfResourceExist(instanceId);
  }, [instanceId, setShowExternalTenantCreationError, checkIfResourceExist]);

  return {
    createResourceForTenant,
    createOwnInfrastructureFn,
    hideExternalTenantCreationError,
  };
};
